import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/invision': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.4 32H40.6C18.2 32 0 50.2 0 72.6V439.4C0 461.8 18.2 480 40.6 480H407.4C429.8 480 448 461.8 448 439.4V72.6C448 50.2 429.8 32 407.4 32zM176.1 145.6C176.5 169 153.7 172.9 149.5 173 134.6 173 122.4 161 122.4 146 122.5 110.8 175.5 110.5 176.1 145.6zM332.8 377C267.2 377 298.7 303 307.8 270.4 321.9 224 262.6 211.4 247.9 271.1L222.1 374.4H177L185.1 341.9C153.6 393.7 90.5 386.3 90.5 337.6 90.6 323.3 91.4 323.6 113.5 233.5H81.7L91.4 197.9H167.8C134.2 331.6 135.2 324.8 134.9 336.1 134.9 357 175.8 349.6 192.3 312.9L212.1 233.5H179.8L189.5 197.9H258.3L249.4 238.4C289.9 162.9 377.3 190.6 351.2 276.4 337 327.5 336.6 327.1 336.3 335.2 336.3 350.7 353.8 357.8 368.1 318.3L386 325C375.5 361.7 356.6 377 332.8 377z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/invision.js
// module id = 2pbJ
// module chunks = 144